import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from '@app/services/auth.service';
import { Invoice } from '@models/settings/billing/invoice.model';
import { Subscription } from '@models/settings/billing/subscription.model';

@Component({
    selector: 'app-invoice-overview',
    templateUrl: './invoice-overview.template.html',
    styleUrls: ['./invoice-overview.style.scss'],
})
export class InvoiceOverviewComponent implements OnInit {
    isLoading = true;

    @Input() invoices: Invoice[] | null = null;
    @Input() subscriptions: Subscription[] = [];

    constructor(public auth: AuthService) {}

    get upcomingInvoice(): Invoice | null {
        if (!this.invoices) {
            return null;
        }

        return this.invoices.find(({ paid }) => !paid);
    }

    getInvoice(invoiceId: string): Invoice | null {
        if (!this.invoices) {
            return null;
        }

        return this.invoices.find(({ identifier }) => identifier === invoiceId);
    }

    ngOnInit(): void {
        this.isLoading = false;
    }
}
